import {
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  listOfvhqybd2zx248 as listOf,
  copyToArray2j022khrow2yi as copyToArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  firstOrNull1982767dljvdy as firstOrNull,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  intercepted2ogpsikxxj4u0 as intercepted,
} from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  split2bvyvnrlcifjv as split,
  contains3ue2qo8xhmpf1 as contains,
} from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { until1jbpn0z3f8lbg as until } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { Regexxgw0gjiagf4z as Regex } from '../../../../kotlin-kotlin-stdlib/kotlin/text/regex.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ExternalServicesClass;
function ExternalServices() {
  if (ExternalServicesClass === VOID) {
    class $ {
      rcu() {
        var tmp = this.qcu_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('baseContext');
        }
      }
      scu(url) {
        return openLink(this.rcu(), url);
      }
      tcu(mimeTypes, $completion) {
        return requestFile(this.rcu(), mimeTypes, $completion);
      }
      ucu(mimeTypes, $completion, $super) {
        mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
        return $super === VOID ? this.tcu(mimeTypes, $completion) : $super.tcu.call(this, mimeTypes, $completion);
      }
      vcu(name, blob, preferredDestination, $completion) {
        return downloadBlob(this.rcu(), name, blob, preferredDestination, $completion);
      }
      downloadBlob(name, blob, preferredDestination, $completion, $super) {
        preferredDestination = preferredDestination === VOID ? DownloadLocation_Downloads_getInstance() : preferredDestination;
        return $super === VOID ? this.vcu(name, blob, preferredDestination, $completion) : $super.vcu.call(this, name, blob, preferredDestination, $completion);
      }
      shareBlob(namesToBlobs, $completion) {
        return shareBlob(this.rcu(), namesToBlobs, $completion);
      }
    }
    initMetadataForObject($, 'ExternalServices', VOID, VOID, VOID, [1, 3, 4]);
    ExternalServicesClass = $;
  }
  return ExternalServicesClass;
}
var ExternalServices_instance;
function ExternalServices_getInstance() {
  return ExternalServices_instance;
}
var DownloadLocation_Downloads_instance;
var DownloadLocation_Pictures_instance;
var DownloadLocation_entriesInitialized;
function DownloadLocation_initEntries() {
  if (DownloadLocation_entriesInitialized)
    return Unit_instance;
  DownloadLocation_entriesInitialized = true;
  DownloadLocation_Downloads_instance = DownloadLocation().ycu('Downloads', 0);
  DownloadLocation_Pictures_instance = DownloadLocation().ycu('Pictures', 1);
}
var DownloadLocationClass;
function DownloadLocation() {
  if (DownloadLocationClass === VOID) {
    class $ extends Enum() {
      static ycu(name, ordinal) {
        return this.c4(name, ordinal);
      }
    }
    initMetadataForClass($, 'DownloadLocation');
    DownloadLocationClass = $;
  }
  return DownloadLocationClass;
}
function DownloadLocation_Downloads_getInstance() {
  DownloadLocation_initEntries();
  return DownloadLocation_Downloads_instance;
}
function set_lastFileInput(_set____db54di) {
  _init_properties_ExternalServices_kt__szl2ax();
  lastFileInput = _set____db54di;
}
function get_lastFileInput() {
  _init_properties_ExternalServices_kt__szl2ax();
  return lastFileInput;
}
var lastFileInput;
function get_validDownloadName() {
  _init_properties_ExternalServices_kt__szl2ax();
  return validDownloadName;
}
var validDownloadName;
function *_generator_requestFile__gf4n3d(_this__u8e3s4, mimeTypes, $completion) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  var tmp = requestFileInput(_this__u8e3s4, mimeTypes, requestFile$lambda, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return firstOrNull(tmp);
}
function requestFile(_this__u8e3s4, mimeTypes, $completion) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_requestFile__gf4n3d.bind(VOID, _this__u8e3s4, mimeTypes), $completion);
}
function requestFiles(_this__u8e3s4, mimeTypes, $completion) {
  mimeTypes = mimeTypes === VOID ? listOf('*/*') : mimeTypes;
  return requestFileInput(_this__u8e3s4, mimeTypes, requestFiles$lambda, $completion);
}
function openLink(_this__u8e3s4, url, newTab) {
  newTab = newTab === VOID ? true : newTab;
  _init_properties_ExternalServices_kt__szl2ax();
  window.open(url, newTab ? '_blank' : '_self');
}
function setClipboardText(_this__u8e3s4, value) {
  _init_properties_ExternalServices_kt__szl2ax();
  window.navigator.clipboard.writeText(value);
}
function downloadBlob(_this__u8e3s4, name, blob, preferredDestination, $completion) {
  preferredDestination = preferredDestination === VOID ? DownloadLocation_Downloads_getInstance() : preferredDestination;
  // Inline function 'kotlin.text.matches' call
  if (!get_validDownloadName().rh(name))
    throw IllegalArgumentException().a1('Name ' + name + ' has invalid characters!');
  var tmp = document.createElement('a');
  var a = tmp instanceof HTMLAnchorElement ? tmp : THROW_CCE();
  var url = URL.createObjectURL(blob);
  a.href = url;
  a.download = name;
  a.target = '_blank';
  a.click();
  // Inline function 'com.lightningkite.kiteui.afterTimeout' call
  var tmp_0 = window;
  var handle = tmp_0.setTimeout(() => {
    URL.revokeObjectURL(url);
    return Unit_instance;
  }, convertToInt(60000n));
}
function shareBlob(_this__u8e3s4, namesToBlobs, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(namesToBlobs, 10));
  var _iterator__ex2g4s = namesToBlobs.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var name = item.af_1;
    var blob = item.bf_1;
    var tmp0_elvis_lhs = lastOrNull(split(blob.type, ['/']));
    var type = tmp0_elvis_lhs == null ? 'png' : tmp0_elvis_lhs;
    var fileName = contains(name, '.') ? name : name + '.' + type;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp = [blob];
    // Inline function 'org.w3c.files.FilePropertyBag' call
    var type_0 = blob.type;
    var lastModified = undefined;
    var o = {};
    o['lastModified'] = lastModified;
    o['type'] = type_0;
    var tmp$ret$4 = new File(tmp, fileName, o);
    destination.v(tmp$ret$4);
  }
  var files = destination;
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$7 = copyToArray(files);
  var data = json([to('files', tmp$ret$7)]);
  // Inline function 'kotlin.js.asDynamic' call
  if (window.navigator.canShare()) {
    // Inline function 'kotlin.js.asDynamic' call
    window.navigator.share(data);
  } else {
    throw IllegalArgumentException().a1("Your browser won't let you share these files.");
  }
}
function requestFileInput(_this__u8e3s4, mimeTypes, setup, $completion) {
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ra5();
  var it = cancellable;
  removeFileInput();
  var tmp = document.createElement('input');
  // Inline function 'kotlin.apply' call
  var this_0 = tmp instanceof HTMLInputElement ? tmp : THROW_CCE();
  var $this$apply = this_0;
  $this$apply.type = 'file';
  $this$apply.hidden = true;
  $this$apply.accept = joinToString(mimeTypes, ',');
  setup($this$apply);
  $this$apply.addEventListener('change', (_unused_var__etf5q3) => {
    var tmp0 = it;
    var tmp0_safe_receiver = $this$apply.files;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, tmp0_safe_receiver.length);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var inductionVariable = this_0.i2_1;
      var last = this_0.j2_1;
      if (inductionVariable <= last)
        do {
          var item = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var index = item;
          var tmp$ret$0 = ensureNotNull(tmp0_safe_receiver.item(index));
          destination.v(tmp$ret$0);
        }
         while (!(item === last));
      tmp = destination;
    }
    var tmp1_elvis_lhs = tmp;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.collections.listOf' call
      tmp_0 = emptyList();
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = tmp_0;
    var tmp$ret$6 = _Result___init__impl__xyqfz8(value);
    tmp0.rc(tmp$ret$6);
    removeFileInput();
    return Unit_instance;
  });
  $this$apply.addEventListener('cancel', (_unused_var__etf5q3) => {
    var tmp0 = it;
    // Inline function 'kotlin.collections.listOf' call
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var value = emptyList();
    var tmp$ret$9 = _Result___init__impl__xyqfz8(value);
    tmp0.rc(tmp$ret$9);
    removeFileInput();
    return Unit_instance;
  });
  ensureNotNull(document.body).appendChild($this$apply);
  set_lastFileInput($this$apply);
  this_0.click();
  return cancellable.sa5();
}
function removeFileInput() {
  _init_properties_ExternalServices_kt__szl2ax();
  var tmp0_safe_receiver = get_lastFileInput();
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    ensureNotNull(document.body).removeChild(tmp0_safe_receiver);
  }
  set_lastFileInput(null);
}
function requestFile$lambda($this$requestFileInput) {
  _init_properties_ExternalServices_kt__szl2ax();
  return Unit_instance;
}
function requestFiles$lambda($this$requestFileInput) {
  _init_properties_ExternalServices_kt__szl2ax();
  $this$requestFileInput.multiple = true;
  return Unit_instance;
}
var properties_initialized_ExternalServices_kt_uo8ror;
function _init_properties_ExternalServices_kt__szl2ax() {
  if (!properties_initialized_ExternalServices_kt_uo8ror) {
    properties_initialized_ExternalServices_kt_uo8ror = true;
    lastFileInput = null;
    validDownloadName = Regex().qh('[a-zA-Z0-9.\\-_]+');
  }
}
//region block: init
ExternalServices_instance = new (ExternalServices())();
//endregion
//region block: exports
export {
  openLink as openLinkrw9xacx95k0e,
  setClipboardText as setClipboardText197l45mq3981x,
  downloadBlob as downloadBlob3lmzpxtmphn66,
  requestFiles as requestFiles2wr6y980phloh,
  requestFile as requestFile18ia1vr614wjr,
  ExternalServices_instance as ExternalServices_instancen7y3lfkh3gae,
};
//endregion

//# sourceMappingURL=ExternalServices.mjs.map
